import { render, staticRenderFns } from "./CsSolicitudesIntDetalle.vue?vue&type=template&id=179db5ca"
import script from "./CsSolicitudesIntDetalle.vue?vue&type=script&lang=js"
export * from "./CsSolicitudesIntDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports